import { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as AddCircle } from "../../../../assets/img/icon/add_circle_black_24dp.svg";
import { ReactComponent as MaskIcon } from "../../../../assets/img/icon/masks_black_24dp.svg";
import { COLOR } from "../../../../config/constant";
import { Device } from "../../../../models/Device";
import {
  getDevice,
  linkDevice,
} from "../../../../services/httpService/deviceRequest";
import { client } from "../../../../services/mqttService/mqttService";
import { GlobalContext } from "../../../contexts/globalContext";
import AnimatedBlock from "../../../ui/atoms/AnimatedBlock/AnimatedBlock";
import Button from "../../../ui/atoms/Button/Button";
import CardDashboard from "../../../ui/atoms/CardDashboard/CardDashboard";
import ExpandData from "../../../ui/atoms/ExpandData/ExpandData";
import PageTitle from "../../../ui/atoms/PageTitle/PageTitle";
import ModalDeviceLink from "../../../ui/organisms/ModalDeviceLink/ModalDeviceLink";
import ModalDeviceSetWifi from "../../../ui/organisms/ModalDeviceSetWifi/ModalDeviceSetWifi";

const LIMIT = 6;
const DeviceList = () => {
  const isMounted = useRef(true);
  const [state, setState] = useState({
    page: 1,
    tpage: 0,
    count: 0,
    device: "",
    message: null,
  });
  const [loading, setLoading] = useState(true);
  const [devices, setDevices] = useState(new Array(LIMIT).fill(0));
  const [wifi, setWifi] = useState(null);
  const [sharedState, dispatch] = useContext(GlobalContext);
  const [modal, setModal] = useState(null);
  const handleCloseModal = () => {
    setModal(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleGetDevice = async (data) => {
    try {
      setLoading(true);
      if (state.message != null)
        setState((prevState) => ({ ...prevState, message: "" }));
      let offset = 0;
      let page = state.page;
      if (data === "next") {
        page += 1;
        setDevices((prevState) => [...prevState, new Array(LIMIT).fill(0)]);
      } else if (data === "prev") {
        page -= 1;
      } else if (data === "refresh") {
        setDevices(new Array(LIMIT).fill(0));
        page = 1;
      }
      offset = (page - 1) * LIMIT;

      let param = `doctor=${sharedState.user._id}&limit=${LIMIT}&offset=${offset}`;
      if (state.device !== "") param = `${param}&device=${state.device}`;

      let { result, count } = await getDevice(param);

      result = result.map((res) => {
        client.publish(`${res._id}/cmd`, JSON.stringify({ cmd: "state" }), {
          qos: 2,
        });
        return new Device(res._id, res.createdAt, res.doctor, res.patient);
      });

      let message = null;
      if (count === 0) {
        message =
          state.device !== "" ? (
            <p className="-mt-3 mb-1">{`Perangkat "${state.device}" tidak ada dalam daftar.`}</p>
          ) : (
            <p className="-mt-3 mb-1">
              Anda belum memiliki perangkat. Klik{" "}
              <span
                className="cursor-pointer underline text-success "
                onClick={() => setModal("register")}
              >
                disini
              </span>{" "}
              untuk menambah perangkat
            </p>
          );
      }

      let tpage = Math.ceil(count / LIMIT);
      if (page !== 1) result = [...devices, ...result];

      if (isMounted.current) setDevices(result);
      if (isMounted.current)
        setState((prevState) => ({
          ...prevState,
          tpage,
          page,
          count,
          message,
        }));
      if (isMounted.current) setLoading(false);
    } catch (error) {
      if (!isMounted.current) return;
      setLoading(false);
      setState((prevState) => ({
        ...prevState,
        message: <p>{error.message} </p>,
      }));
    }
  };

  const handleOpenConfirm = (_id) => {
    dispatch("confirm", {
      show: true,
      message: `Lanjutkan hapus perangkat ${_id}`,
      callback: () => handleUnlinkDevice(_id),
    });
  };

  const handleUnlinkDevice = async (_id) => {
    try {
      dispatch("isLoading", true);
      dispatch("confirm", {
        show: false,
        message: "",
        callback: null,
      });
      await linkDevice({
        _id,
        action: "unlink",
      });
      if (!isMounted.current) return null;
      dispatch("isLoading", false);
      handleGetDevice();
    } catch (error) {
      if (!isMounted.current) return null;
      dispatch("alert", {
        type: "warning",
        message: error.message,
        show: true,
      });
      dispatch("isLoading", false);
    }
  };
  const handleMqtt = () => {
    client.subscribe(`+/state`, { qos: 1 });
    client.on("message", async (topic, message) => {
      message = message.toString();
      const device = topic.split("/")[0];
      if (!isMounted.current) return;
      await setDevices((prevState) => {
        let updatedValue = [...prevState];
        let idx = updatedValue.findIndex((dev) => dev._id === device);
        if (idx >= 0) updatedValue[idx]["state"] = true;
        return updatedValue;
      });
    });
  };

  useEffect(() => {
    handleGetDevice();
    handleMqtt();
    return () => {
      client.unsubscribe(`+/state`);
      isMounted.current = false;
    };
  }, []);

  return (
    <>
      <ModalDeviceLink
        show={modal === "register"}
        handleClose={handleCloseModal}
        handleUpdate={handleGetDevice}
      />
      {wifi !== null && (
        <ModalDeviceSetWifi
          device={wifi}
          handleClose={(input) => {
            if (input !== undefined) {
              setDevices((prevState) => {
                let updatedValue = [...prevState];
                let idx = updatedValue.findIndex((dev) => dev._id === input);
                if (idx >= 0) updatedValue[idx]["state"] = true;
                return updatedValue;
              });
            }
            setWifi(null);
          }}
        />
      )}

      <div className="mt-2 lg:mt-6">
        <PageTitle
          title="Halaman Perangkat"
          description="Dapatkan informasi perangkat yang anda miliki, beserta fitur untuk mengendalikannya"
          icon={
            <MaskIcon className="w-10 sm:w-12 lg:w-16 h-10 sm:h-12 lg:h-16 fill-current text-white" />
          }
        />

        {/* SUBMENU */}
        <div className="mt-10 flex flex-col xl:flex-row justify-start xl:justify-between items-center space-y-4 xl:space-y-0">
          {/* LEFT SUBMENU */}
          <div className="w-full xl:w-2/3 flex flex-wrap">
            <div className="w-full sm:w-2/3 md:w-96 flex space-x-2 items-center mr-2 mt-2">
              <div className="text-primary font-medium flex-shrink-0 hidden md:block">
                Perangkat :
              </div>
              <input
                className="w-full border-b border-primary text-primary px-1 focus:outline-none placeholder-primary placeholder-opacity-40"
                type="text"
                placeholder="Nama Perangkat"
                name="device"
                value={state.device}
                onChange={handleChange}
                onKeyPress={(e) => {
                  if (e.key === "Enter") handleGetDevice("refresh");
                }}
              />
              <Button
                className="w-24 flex-shrink-0 bg-primary rounded px-2 py-1 text-sm text-white "
                handleClick={() => handleGetDevice("refresh")}
              >
                Cari
              </Button>
            </div>
          </div>
          {/* RIGHT SUBMENU */}
          <div className="w-full xl:w-1/3 flex space-x-3 justify-end mt-3 xl:mt-0">
            <div
              className="text-primary cursor-pointer flex items-center "
              onClick={() => setModal("register")}
            >
              <div>
                <AddCircle fill={COLOR.PRIMARY} className="w-6 h-6" />
              </div>
              <div className="ml-1 border-b border-transparent hover:border-primary">
                Tambah Perangkat
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12">
          <CardDashboard
            title="Perangkat"
            icon={<MaskIcon fill={"#fafafa"} className="w-5 h-5" />}
          >
            <div className="relative pt-6">
              {!loading &&
                (state.message === null ? (
                  <p className="absolute top-1 right-0 text-sm text-gray-800 text-opacity-50 text-sm">
                    <span className="hidden md:inline-block">Menampilkan</span>{" "}
                    {`${devices.length} dari ${state.count} data`}
                  </p>
                ) : (
                  <>{state.message}</>
                ))}
              <div className="overflow-x-auto">
                {devices.length !== 0 && (
                  <>
                    <table className="w-full my-3">
                      <thead>
                        <tr className="bg-secondary text-white">
                          <th className="px-2 py-2 text-left border border-white">
                            Tanggal Registrasi
                          </th>
                          <th className="px-2 py-2 text-left border border-white">
                            Nama Perangkat
                          </th>
                          <th className="px-2 py-2 text-left border border-white">
                            Pengguna
                          </th>
                          
                          <th className="px-2 py-2 text-left border border-white">
                            Aksi
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {devices.map((device, idx) => {
                          if (device._id === undefined)
                            return (
                              <tr className="" key={"dummy-device-" + idx}>
                                <td className="px-1 py-1.5">
                                  <AnimatedBlock className="h-6" />
                                </td>
                                <td className="px-1 py-1.5">
                                  <AnimatedBlock className="h-6" />
                                </td>
                                <td className="px-1 py-1.5">
                                  <AnimatedBlock className="h-6" />
                                </td>
                               
                                <td className="px-1 py-1.5">
                                  <AnimatedBlock className="h-6" />
                                </td>
                              </tr>
                            );
                          return (
                            <tr
                              className={idx % 2 === 0 ? "bg-gray-100" : ""}
                              key={"device-" + device._id}
                            >
                              <td className="px-2 py-1.5 border-t">
                                {device.createdAt}
                              </td>
                              <td className="px-2 py-1.5 border-t">
                                {device._id}
                              </td>
                              <td className="px-2 py-1.5 border-t">
                                {device.doctor ? device.doctor.name : "-"}
                              </td>
                              
                              <td
                                className="px-2 py-1.5 border-t w-44 "
                                style={{
                                  tableLayout: "fixed",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {/* {device.state !== true && (
                                  <div
                                    className="cursor-pointer inline-block bg-secondary text-white rounded-full px-2 mr-2"
                                    onClick={() => {
                                      window.scrollTo({
                                        top: 0,
                                        left: 0,
                                        behavior: "smooth",
                                      });
                                      setWifi(device);
                                    }}
                                  >
                                    Set Wifi
                                  </div>
                                )} */}
                                <Button
                                  className="px-1.5 rounded-md border border-warning text-warning mr-2"
                                  handleClick={() =>
                                    handleOpenConfirm(device._id)
                                  }
                                >
                                  Hapus
                                </Button>

                                <Link to={`/device/${device._id}`}>
                                  <div className="inline-block px-1.5 rounded-md border border-secondary text-secondary focus:outline-none focus:ring-2">
                                    Lihat
                                  </div>
                                </Link>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>

                    <ExpandData
                      page={state.page}
                      tpage={state.tpage}
                      loading={loading}
                      handleMoreData={() => handleGetDevice("next")}
                    />
                  </>
                )}
              </div>
            </div>
          </CardDashboard>
        </div>
      </div>
    </>
  );
};

export default DeviceList;
